import { render, staticRenderFns } from "./BelfixJobMessage.vue?vue&type=template&id=0d2713d4&"
import script from "./BelfixJobMessage.vue?vue&type=script&lang=js&"
export * from "./BelfixJobMessage.vue?vue&type=script&lang=js&"
import style0 from "./BelfixJobMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports